import i18next from 'i18next'

export const tUnchecked = (key: string | string[], options?: object): string =>
  (i18next.t as (key: string | string[], options?: object) => string)(key, options)
